const ROUTES = [
  ["/dashboard", "Dashboard", "Overview"],
  ["/certified/summary", "Certified Summary", "Inventory"],
  ["/certified", "Certified Diamonds", "Inventory"],
  ["/loose", "Loose Parcels", "Inventory"],
  ["/jewelry-stock", "Jewelry Stock", "Inventory"],
  ["/jewelry-duplicate-ids", "Duplicate IDs", "Inventory"],
  ["/jewelry-sets", "Jewelry Sets", "Inventory"],
  ["/item-names", "Item Names", "Inventory"],
  ["/stocktake", "Stock-take", "Inventory"],
  ["/jewelry-import", "Import Jewelry", "Workshop"],
  ["/jewelry-library", "Image Library", "Workshop"],
  ["/jewelry", "Create Jewelry", "Workshop"],
  ["/gold-stock", "Gold Stock", "Workshop"],
  ["/production", "Production", "Workshop"],
  ["/purchases/new", "New Purchase", "Purchasing"],
  ["/supplier-returns/new", "New Supplier Return", "Purchasing"],
  ["/supplier-returns", "Supplier Returns", "Purchasing"],
  ["/purchases", "Purchases", "Purchasing"],
  ["/reorder", "Reorder", "Purchasing"],
  ["/sales/new", "New Sale", "Sales"],
  ["/sales", "Sales", "Sales"],
  ["/sales-agents", "Sales agents", "Sales"],
  ["/inquiries", "Inquiries", "Sales"],
  ["/sold", "Sold", "Sales"],
  ["/contacts", "Contacts", "Business"],
  ["/catawiki/baskets", "Auction Baskets", "Catawiki"],
  ["/catawiki/photography", "Photography Queue", "Catawiki"],
  ["/catawiki/listing", "Listing", "Catawiki"],
  ["/catawiki/submitted", "Catawiki Stock", "Catawiki"],
  ["/catawiki/shipping", "Shipping & Fulfilment", "Catawiki"],
  ["/catawiki/payments", "Payments & Results", "Catawiki"],
  ["/catawiki/profit", "Profit & VAT", "Catawiki"],
  ["/reports", "Business Reports", "Business"],
  ["/documents", "Documents & Exports", "Business"],
  ["/audit", "Audit Log", "Business"],
  ["/team", "Team", "Admin"],
  ["/login-activity", "Login Activity", "Admin"],
  ["/settings", "Settings", "Admin"],
  ["/help", "Help Center", "Support"],
];

export function pageMetaFor(pathname, search = "") {
  if (pathname === "/sales" && new URLSearchParams(search).get("view") === "balances") {
    return { title: "Payments & Balances", section: "Business", hideContentTitle: true };
  }
  const match = ROUTES.find(([path]) => pathname === path || pathname.startsWith(`${path}/`));
  if (!match) return { title: "Milora ERP", section: "Workspace", hideContentTitle: false };
  const [path, title, section] = match;
  const isDetail = pathname !== path && !path.endsWith("/new");
  return { title: isDetail ? `${title} detail` : title, section, hideContentTitle: !isDetail };
}
